import { FileData } from '@ygtechnologies/rubus-frontend-utilities';
import { StandardReply } from '@/types';
import { getChatApiUrl, request } from '@/utils/ajax';

export function getStandardRepliesByProfileId(profileId: number): Promise<StandardReply[]> {
    return request(getChatApiUrl() + `/api/standardreplies`, { query: { profileId } }).then((x) => x.json());
}

export async function editStandardReply(id: number, standardReply: StandardReplyUpdateOptions): Promise<StandardReply> {
    return request(getChatApiUrl() + `/api/standardreplies/${id}`, {
        method: 'PUT',
        json: true,
        body: standardReply,
    }).then((r) => r.json());
}

export async function deleteStandardReply(id: number) {
    await request(getChatApiUrl() + `/api/standardreplies/${id}`, { method: 'DELETE' });
}

export async function addStandardReply(standardReply: StandardReplyUpdateOptions): Promise<StandardReply> {
    return request(getChatApiUrl() + `/api/standardreplies`, {
        method: 'POST',
        json: true,
        body: standardReply,
    }).then((r) => r.json());
}

export interface StandardReplyUpdateOptions {
    title: string;
    text: string;
    comment: string;
    profileId: number;
    attachments: StandardReplyUpdateOptionsAttachment[] | null;
}
export interface StandardReplyUpdateOptionsAttachment {
    id: number | null;
    file: FileData | null;
}
